import React from 'react';
import HtmlContentViewer from '../components/HtmlContentViewer';
import styled from 'styled-components';

const PageContainer = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  padding: 2rem 1rem;
`;

const VeloBessisPage = () => {
  return (
    <PageContainer>
      <HtmlContentViewer 
        filePath="publicaciones/enlaweb/velo-bessis.htm"
        title="La polémica sobre el velo en Francia: contenido y consecuencias - Sophie Bessis"
      />
    </PageContainer>
  );
};

export default VeloBessisPage; 